import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ya4nltd3: FaireBrandEntity = {
  token: "b_ya4nltd3",
  type: "brand",
  name: "Ameico",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb58d443e6f9d92d3cc00249477f44ea24ba5b18c61e850b0bbd600f44349e2e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/893d0d619494da1675244fb9052124fd62302a4e09d1fe5c0c0bf2079cafbd66.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cb58d443e6f9d92d3cc00249477f44ea24ba5b18c61e850b0bbd600f44349e2e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/893d0d619494da1675244fb9052124fd62302a4e09d1fe5c0c0bf2079cafbd66.jpeg",
  location: "New Milford, CT, USA",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "Ameico, founded in 1995, is the sole US distributor of a curated collection of contemporary design products from around the world. Our products represent the best in modern and contemporary design in the areas of lighting, home and personal accessories. Crafted to stand the test of time, these designs span a century of creativity and are imbued with a high degree of innovation and aesthetics. We believe life is made better by good design and to consume less and consume wisely. Our commitment is evident in the products we source, designed for longevity, our shipping methods, and our partnerships with certified vendors.   ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:18.458Z",
    importedBy: "entity-db-cli",
  },
};
